import { useEffect, useState} from 'react';

import axios from 'axios';

const useFetchData = ({searchdata, setLoading}) => {
  const [data, setData] = useState({});
  

  useEffect(() => {
    if (!searchdata || !setLoading) return;
    const fetchData = async () => {
      try {
        setLoading(true);
        const { data: response } = await axios.get(`https://bulkify.in/api/searchproduct.php?searchdata=${searchdata}`);
        setData(response);
      } catch (error) {
        console.error(error)
      }
      finally{
        setLoading(false);
      }
      
    };

    fetchData();
  }, [searchdata, setLoading]);

  return {data};
};

export default useFetchData;